module.exports = __webpack_public_path__ + "assets/media/kelvin-1.f9655636.png";